<template>
  <div class="ui-category-body">
    <div class="category-flex">
      <div class="category-sidebar">
        <ul>
          <li class="item"
              v-for='item in items'
              v-bind:key="item.id"
              v-on:click='(item.children && item.children.length)?onItemClick(item):goProduct(item.id)'
              v-bind:class="{'sidbaractive': (currentItem && item.id == currentItem.id), 'noActive' : (currentItem && item.id != currentItem.id)}">
            <a>{{ item.value }}</a>
          </li>
        </ul>
      </div>
      <div class="category-content" ref="content" v-if='currentItem'>
        <div class="content-inner">
          <div class="content-heading">
            <h2>{{ currentItem.value }}</h2>
            <span>Explore popular categories</span>
          </div>
          <div class="category-grid">
            <div class="category-card" v-for='item in visibleCategories' v-bind:key = "item.id" v-on:click='goProduct(item.id)'>
              <div class="category-image"><img :src="imageSrc(item)" :data-category-id="item.id" @error="replaceImage" /></div>
              <div class="category-name">{{item.value}}</div>
            </div>
            <div class="category-card view-all" v-on:click='goProduct(currentItem.id)'>
              <div class="category-image"><span class="view-all-icon"><i></i><i></i><i></i><i></i></span></div>
              <div class="category-name">View all</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import { searchGoodsList } from '../../../api/homesearch'
export default {
  data () {
    return {
      fallbackImage: require('../../../assets/image/no_image.jpg'),
      categoryImages: {},
      imageRequests: {}
    }
  },
  computed: {
    ...mapState({
      items: state => state.goodsclass.items,
      currentItem: state => state.goodsclass.currentItem
    }),
    visibleCategories () {
      if (!this.currentItem || !this.currentItem.children) return []
      const result = []
      this.currentItem.children.forEach(group => {
        if (group.children && group.children.length) {
          group.children.forEach(item => result.push(item))
        } else {
          result.push(group)
        }
      })
      return result
    }
  },
  watch: {
    visibleCategories: {
      handler () {
        this.loadMissingImages()
      },
      immediate: true
    }
  },
  created () {
    this.getGoodsclassList()
  },
  methods: {
    ...mapMutations({
      saveCurrentGoodsclassItem: 'saveCurrentGoodsclassItem'
    }),
    ...mapActions({
      fetchGoodsclassList: 'fetchGoodsclassList'
    }),
    getGoodsclassList () {
      if (!(this.items && this.items.length)) {
        Indicator.open()
      }
      this.fetchGoodsclassList().then((response) => {
        Indicator.close()
      }, (error) => {
        Toast(error.message)
        Indicator.close()
      })
    },
    onItemClick (item) {
      this.saveCurrentGoodsclassItem(item)
      if (this.$refs.content) this.$refs.content.scrollTop = 0
    },
    replaceImage (event) {
      event.target.src = this.fallbackImage
      const itemId = event.target.getAttribute('data-category-id')
      const item = this.visibleCategories.find(category => String(category.id) === String(itemId))
      if (item) this.loadProductImage(item)
    },
    imageSrc (item) {
      return this.hasCategoryImage(item) ? item.image : (this.categoryImages[item.id] || this.fallbackImage)
    },
    hasCategoryImage (item) {
      return Boolean(item && item.image && !/default_goods_image|no_image/i.test(item.image))
    },
    loadMissingImages () {
      this.visibleCategories.forEach(item => {
        if (!this.hasCategoryImage(item) && !this.categoryImages[item.id]) this.loadProductImage(item)
      })
    },
    loadProductImage (item) {
      if (!item || !item.id || this.imageRequests[item.id]) return
      this.$set(this.imageRequests, item.id, true)
      searchGoodsList({ cate_id: item.id, page: 1 }).then(response => {
        const goodsList = response.result && response.result.goods_list
          ? response.result.goods_list
          : []
        const goods = goodsList.find(product => product.goods_image_url || product.goods_img_480 || product.goods_image_format)
        if (goods) {
          const image = goods.goods_image_url || goods.goods_img_480 || goods.goods_image_format
          this.$set(this.categoryImages, item.id, image)
        }
      }).catch(() => {
        // The default placeholder remains visible when the category has no products.
      })
    },
    goProduct (id) {
      let params = { 'cate_id': id }
      this.$router.push({ 'name': 'HomeGoodslist', 'query': params })
    }
  }
}
</script>

<style scoped lang="scss">
  .ui-category-body{
    width: 100%;
    height: calc(100% - 2.8rem);
    background: #fff;
    -webkit-overflow-scrolling: touch;
    .category-flex {
      display: flex;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      width: 100%;
      height: 100%;
      .category-sidebar {
        flex: 0 0 6.2rem;
        background-color: #f5f5f5;
        overflow-y: scroll;
        padding-bottom: 2.5rem;
        ul {
          border-right: 0.5px solid #E8EAED;
          li {
            display: block;
            min-height: 3.25rem;
            padding: .7rem .45rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            a {
              color: #333;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              font-size: .68rem;
              line-height: .95rem;
              text-align: left;
            }
          }
          li.noActive {
            background-color: #F0F2F5;
            border-left: 0.1rem solid transparent;
            a {
              color: #333;
            }
          }
          li.sidbaractive{
            background-color: #FFFFFF;
            border-left: 0.14rem solid #e93b3d;
            a {
              font-weight:600;
              color: #e93b3d;
            }
          }
        }
      }
      .category-content {
        width: 100%;
        background-color: #fff;
        overflow: auto;
        padding: 0 .7rem;
        box-sizing: border-box;
        .content-inner { padding: 1rem 0 2rem; }
        .content-heading {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          padding: 0 .05rem .8rem;
          h2 { font-size: .95rem; font-weight: 700; white-space: nowrap; }
          span { color: #8a8d91; font-size: .52rem; }
        }
        .category-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          column-gap: .35rem;
          row-gap: 1.05rem;
        }
        .category-card { text-align: center; min-width: 0; cursor: pointer; }
        .category-image {
          width: 3.8rem;
          height: 3.8rem;
          margin: 0 auto .38rem;
          overflow: hidden;
          background: #f5f5f5;
          display: flex;
          align-items: center;
          justify-content: center;
          img { width: 100%; height: 100%; object-fit: contain; }
        }
        .category-name {
          min-height: 1.65rem;
          color: #25272a;
          font-size: .62rem;
          line-height: .82rem;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .view-all-icon {
          width: 1.45rem;
          height: 1.45rem;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: .2rem;
          i { display: block; background: #73777b; }
        }
      }
    }
  }

  // Keep the three-column composition usable on compact phones.
  @media only screen and (max-width: 430px) {
    .category-sidebar { flex-basis: 5.6rem !important; }
    .category-content { padding-left: .55rem !important; padding-right: .55rem !important; }
    .content-heading {
      display: block !important;
      h2 { font-size: .9rem !important; }
      span { display: none; }
    }
    .category-image { width: 3.45rem !important; height: 3.45rem !important; }
    .category-grid { column-gap: .15rem !important; row-gap: .9rem !important; }
  }

  @media only screen and (max-width: 360px) {
    .category-sidebar { flex-basis: 5.2rem !important; }
    .category-sidebar li a { font-size: .62rem !important; }
    .category-image { width: 3.05rem !important; height: 3.05rem !important; }
    .category-name { font-size: .57rem !important; }
  }
</style>
